export default[
    {
        show(row,extra){
            return(
               row.wjlx==='ycq'&&row.shbj==='1'
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '该文件尚未生效，请等待招管通备案通过';
        }
    }
]